var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9375 15.75H7.21875M7.21875 15.75C7.21875 20.4617 11.0383 24.2812 15.75 24.2812M7.21875 15.75C7.21875 11.0383 11.0383 7.21875 15.75 7.21875M15.75 24.2812C20.4616 24.2812 24.2812 20.4617 24.2812 15.75M15.75 24.2812V27.5625M15.75 7.21875C20.4617 7.21875 24.2812 11.0383 24.2812 15.75M15.75 7.21875V3.9375M24.2812 15.75H27.5625M20.3438 15.75C20.3438 18.2871 18.2871 20.3438 15.75 20.3438C13.2129 20.3438 11.1562 18.2871 11.1562 15.75C11.1562 13.2129 13.2129 11.1562 15.75 11.1562C18.2871 11.1562 20.3438 13.2129 20.3438 15.75Z",
    stroke: "#F2F5F8",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.6f712dea8c4d427e9d1488e319f618a0.svg";
export { ForwardRef as ReactComponent };